import {
  CREATE_SETTING_FILTER_SCHEME,
  SET_TEMPLATE_SETTINGS,
  UPDATE_TEMPLATE_SETTINGS,
} from "store/constans";
import { getTableColumns, getTemplateSetting, getTemporarySetting } from "store/selectors/templateSettings";
import { applyFiltesrs } from "utils/builder/IScheduleLogic";
import { getColumnType } from "utils/helpers";
import { FilterSettingsService } from "utils/services/filterSettings.service";
import { updateTable } from "./table";

export const setTemplateSettingsAC = ({ updateData }) => {
  return {
    type: SET_TEMPLATE_SETTINGS,
    payload: {
      updateData,
    },
  };
};

export const updateTemplateSettingsAC = (updateData) => {
  return {
    type: UPDATE_TEMPLATE_SETTINGS,
    payload: {
      updateData,
    },
  };
};

export const updateFilterTable = (updateTableWithoutFilterTable = true, callback) => async (dispatch, getState) => {

  const templateSetting = getTemplateSetting(getState())
  const temporarySetting = getTemporarySetting(getState())
  const tableColumns = getTableColumns(getState())

  const columnId = temporarySetting.metaData.name
  const currentColumnType = getColumnType(temporarySetting.type);

  const columnType = currentColumnType;

  const currentFiltersItems = temporarySetting.settingsItems?.filters ?? []

  const selectedProperties = tableColumns.reduce(((acc, column) => {
      const {isCustomColumn, name} = column.metaData
      if (!isCustomColumn) {
        acc.push(name)
      }
      return acc
  }), [])
  
  const groups = templateSetting.groups ?? []

  const columnFilterScheme = FilterSettingsService.createFilterScheme({
    columnId: columnId,
    columnKey: columnId,
    columnType,
    filterItems: currentFiltersItems,
  });

  const _updateFilterScheme = (columnFilterScheme) => {
    const currentFilterSchemes = templateSetting.filtersSchemes
    const currentColumnFilterScheme = currentFilterSchemes[columnId]
    return {...currentFilterSchemes, [columnId] : {...currentColumnFilterScheme, ...columnFilterScheme}}
  }

  const newColumnFilterScheme = _updateFilterScheme(columnFilterScheme)

  await dispatch({
    type: CREATE_SETTING_FILTER_SCHEME,
    payload: {filtersSchemes: newColumnFilterScheme},
  })

  if (updateTableWithoutFilterTable) {
    applyFiltesrs(newColumnFilterScheme)
    dispatch(updateTable(selectedProperties, groups));
  }

  if (callback) {
    callback();
  }
};
